export default __webpack_public_path__ + "static/media/product-5.f9060afb.jpg";